export const confirmModalTypesValues = {
  successModal: 1,
  errorModal: 2,
  infoModal: 3
};
